// extracted by mini-css-extract-plugin
export default {"container":"qG-z","disabled":"rG-z","bgBlack":"sG-z","content":"tG-z","countdown":"uG-z","topCaption":"vG-z","topHeading":"wG-z","heading":"xG-z","copy":"yG-z"};